@if (warningBadgeValue | async; as value) {
  <span class="warning-badge"
    >
    {{value}}
  </span>
}
